/* ----------------------------------
 - variables.js -
 JS全般で利用されるグローバル変数定義
---------------------------------- */

import { Level } from './constants'

const debug = (process.env.NODE_ENV === 'debug' || process.env.NODE_ENV === 'development')

export default {
  // #### Param [System]
  System: {
    logLevel: debug ? Level.DEBUG : Level.INFO
  },
  // #### Param [Session]
  Session: {
    key: 'rbXYfVf578t9kNnxxBExRDWH9dzGDuTW'
  },
  // #### Param [LocalStorage]]
  LocalStorage: {
    key: 'rKN9SPxR6HAYcrnVDrzFPniZQ3eX6i7d'
  },
  // #### Param [Api]
  Api: {
    // ## Time out for API request(Ajax) in milisecond
    timeout: 120000,
    // ## Time out for file upload in milisecond
    
    timeoutUpload: 300000

    // #### for remote-api-test
    // ## API base path to Application Server
    // root: 'http://192.168.xxx.xxx/api'
  },
  // #### Param [Site]
  Site: require(`@/data/site.${process.env.NODE_ENV}.json`)
}
